module.exports = __webpack_public_path__ + "media/application/images/2018/insta-blue-a2e1c1d61ba2e2bcd0d505d1593461f4.svg";